function getCustomControlDefaultValue(customComponentName) {
  switch (customComponentName) {
    case 'StatesSelector':
    case 'ServiceProvider':
    case 'BrandsAll':
    case 'ProductLineAll':
    case 'ServiceAdministratorClient':
    case 'ServiceProviderRecommendedLocations':
    case 'ServiceProviderLocationNumber':
    case 'DynamicDateRangePicker':
    case 'JobStatusSelector':
    case 'DispatchStatusSelector':
    case 'ClaimStatusSelector':
    case 'ServiceProviderMainContact':
    case 'AddressValidator':
    case 'UserRoleSelect':
    case 'ValidatedAddress':
    case 'ActiveInactiveDeleted':
    case 'Industry':
    case 'SDButtonsForm':
      return null;
    case 'ContractorComplianceMultiSelect':
    case 'ActiveInActiveEnum':
    case 'ActiveInActiveStatus':
    case 'PhoneNumber':
    case 'YesNo':
    case 'UserStatusSelect':
    case 'InsightConfigName':
    case 'InsightConfigValue':
      return '';
    case 'AttachmentList':
    case 'IndustrySelector':
      return [];
    default:
      throw new Error(
        `Plaase configure default value for ${customComponentName} in src/product-framework/utils/getDefaultValueByControl.jsx`,
      );
  }
}

/*
 Used in packages/frontend/src/ui-framework/components/Forms/FormSearchAdvanced.jsx to set default values if not provided
*/
function getDefaultValueByControl({ field }) {
  switch (field?.control) {
    case 'custom':
      return getCustomControlDefaultValue(field.customComponent);
    default:
      return '';
  }
}

export default getDefaultValueByControl;
